import React from 'react';
import FormGerenteCambista from '../_Components/FormGerenteCambista';
import qs from 'qs';
import AdminTemplate from './AdminTemplate';


const AdminCadastroGerente  = (props) => {
    const { id } = qs.parse(props.location.search, { ignoreQueryPrefix: true })
    const tutorId = JSON.parse(localStorage.getItem("user")).tutorId
    const admin = JSON.parse(localStorage.getItem("user"))
    return (
        <AdminTemplate label="Cadastro de Gerentes">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Cadastro de Gerentes</h4>
                            </div>
                            <div className="card-body">
                                <FormGerenteCambista perfil="GERENTE" admin={admin} tutorId={tutorId} id={id}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminTemplate>

    )
}

export default AdminCadastroGerente; 
